import Vue from 'vue'
Vue.prototype.imgUrl = 'https://www.ai-lingxin.com:6443'



// WEBPACK FOOTER //
// ./src/assets/js/common.js